import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Typography,
  Divider,
} from '@mui/material';
import CompassCalibrationIcon from '@mui/icons-material/CompassCalibration';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { AttachFileOutlined, Visibility, VisibilityOff } from '@mui/icons-material';

import {
  GenericContainer,
  Buttons,
  GeoLocationGeneric,
  AlertConfirmAsync,
  AlertConfirm,
  Alert,
  ToastNotification,
  CustomLoadingOverlay,
} from '../../components';
import { coreFunctions } from '../../utils';
import { signDocument, extractSignatureFromPem, verifySignature, toBase64 } from './SignFunctions';
import { documentsRequests } from '../../services';
import { useTranslation } from 'react-i18next';
import { MAIN_COLOR } from 'theme/palette';
import { renderToString } from 'react-dom/server';

export default function AdvancedSignature() {
  const navigate = useNavigate();
  const location = useLocation();
  const firmaLocal = sessionStorage.getItem('firmab64');
  const { t } = useTranslation();
  const keyref = useRef();
  const cerref = useRef();

  // Local state
  const [alertMessage, setAlertMessage] = useState(true);
  const [statusFirma, setStatusFirma] = useState(false);
  const [statusOCSP, setStatusOCSP] = useState(false);
  const [statuSingBlocked, setStatuSingBlocked] = useState(false);
  const [values, setValues] = React.useState({
    amount: '',
    password: '',
    weight: '',
    weightRange: '',
    showPassword: false,
  });
  const [keyfile, setkeyfile] = useState();
  const [cerfile, setcerfile] = useState();
  const [lat, setLat] = useState('');
  const [lon, setLon] = useState('');
  const [loadView, setLoadView] = useState(false);
  const [listSignDocuments, setListSignDocuments] = useState(() => {
    const { ListDocuments } = location.state || {};
    return ListDocuments || [];
  });

  useEffect(() => {
    if (listSignDocuments.length === 0) return;

    console.log('listSignDocuments--------usefecte-----', listSignDocuments);
    let IsCompletedSign = listSignDocuments.every((document) => document.SendSign);
    if (IsCompletedSign) {
      console.log('IsCompletedSign-------------', IsCompletedSign);
      // TODO: Implementar la siguiente etapa de acuerdo a la respuesta de las APIs.
      // const { Stage } = file.items;

      // let nextComponent = 'AdvancedSignature';
      // coreFunctions.DoNextStage({
      //   navigate,
      //   nextComponent,
      //   State: {
      //     stageName: Stage.Name,
      //     stageId: Stage.Id,
      //     folioId: file.items.Id,
      //     ListDocuments: documentList,
      //   },
      // });
      return null;
    }
  }, [listSignDocuments]);

  useEffect(() => {
    if (!alertMessage) return;

    AlertConfirm(
      {
        icon: 'warning',
        html: (
          <Box sx={{ mt: 1, p: 2, display: 'flex', textAlign: 'justify' }}>
            <Typography>{t('signature_advanced_alert')}</Typography>
          </Box>
        ),
        okbtntext: t('accept_capture'),
        notbtntext: t('reject_capture'),
      },
      (result) => {
        console.log('result alert------: ', result);
        if (result.isConfirmed) {
          setAlertMessage(false);
        } else if (result.dismiss === 'cancel' && result.isDismissed) {
          setAlertMessage(false);
        } else {
          console.log('result alert---2---: ', result);
          setAlertMessage(false);
          setAlertMessage(true);
        }
      },
    );
  }, [alertMessage]);

  const handleKeyInput = () => {
    keyref.current.click();
  };
  const handleKeyFile = (e) => {
    setkeyfile(e.target.files[0]);
  };
  const handleCerInput = () => {
    cerref.current.click();
  };
  const handleCerFile = (e) => {
    setcerfile(e.target.files[0]);
  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleSignature = async () => {
    setLoadView(true);
    console.log('props------', location.state);
    if (!lat && !lon) {
      Alert({
        icon: 'error',
        text: `Por favor verifica que tu ubicación este activada.`,
        okbtntext: 'Aceptar',
      });
      setLoadView(false);
      return null;
    }

    if (keyfile && cerfile && values.password) {
      try {
        const cerb64 = await toBase64(cerfile);
        const documentsProcedSign = [];
        const confirmedDocuments = [];

        Promise.all(
          listSignDocuments.map(async (document) => {
            let firmab64 = '';

            let documentTosign = await documentsRequests.DownloadDocumentAsync(
              document.Document.Id,
            );
            // console.log('documentToSign------------: ', documentTosign.Body?.B64Content);

            let documentB64 = documentTosign.Body?.B64Content;
            // console.log('documentB64------------: ', documentB64);

            if (!firmaLocal) {
              // console.log("FIRMA DE DOCUMENTO EN PROCESO");
              try {
                const result = await signDocument({
                  certfile: cerfile,
                  keyfile: keyfile,
                  password: values.password,
                  document: documentB64,
                });
                // console.log('FIRMA PEM', result);

                if (result.firma) {
                  firmab64 = extractSignatureFromPem({ pemSignature: result.firma });

                  // console.log("Firma B64", firmab64);
                  if (firmab64) {
                    setStatusFirma(true);
                    setStatuSingBlocked(true);
                  }

                  const verificacion = await verifySignature({
                    certfile: cerfile,
                    document: documentB64,
                    pemSignature: result.firma,
                  });
                  // console.log('VERIFICACION', verificacion);
                } else {
                  Alert({ icon: 'error', text: result.status });
                  return { ...document, SendSign: false };
                }
              } catch (error) {
                Alert({ icon: 'error', text: error });
                return { ...document, SendSign: false };
              }
            }

            if (navigator.onLine) {
              // ------------------- INICIA Verificacion de CERTIFICADO OCSP -------------------
              const splittedCerName = cerfile.name.split('.');
              const bodyVerifyOCSP = {
                CertificadoB64: cerb64.split(',')[1],
                NombreCertificado: splittedCerName[0],
                ExtensionCertificado: `.${splittedCerName[splittedCerName.length - 1]}`,
                File_Id: location.state.folioId,
                Document_Id: document.Document.Id,
              };
              try {
                let resVerifyCer = await documentsRequests.VerifyStatusCertificate(bodyVerifyOCSP);

                console.log('RESPONSE VERIFY OCSP', resVerifyCer);

                if (
                  resVerifyCer.Body?.Status.toUpperCase() === 'UNKNOW' ||
                  resVerifyCer.Body.Status.toUpperCase() === 'UNKNOWN'
                ) {
                  Alert({
                    icon: 'warning',
                    text: resVerifyCer.Body.MessageUknowState || resVerifyCer.Body.MessageConfirm,
                  });
                  return { ...document, SendSign: false };
                } else if (resVerifyCer.Body.Status === 'vigente confirmado') {
                  documentsProcedSign.push({
                    documentId: document.Document.Id,
                    messageConfirm: resVerifyCer.Body.MessageConfirm,
                    cerb64: cerb64.split(',')[1],
                    firmab64: firmab64,
                    fileId: location.state.folioId,
                    IsValidedSat: true,
                  });
                } else if (
                  resVerifyCer.Body.Status === 'good' ||
                  resVerifyCer.Body.Status === 'vigente sin validar'
                ) {
                  documentsProcedSign.push({
                    documentId: document.Document.Id,
                    messageConfirm: '',
                    cerb64: cerb64.split(',')[1],
                    firmab64: firmab64,
                    fileId: location.state.folioId,
                    IsValidedSat: false,
                  });
                }
              } catch (error) {
                Alert({ icon: 'error', text: error });
                return { ...document, SendSign: false };
              }
            } else {
              handleNoInternet();
              return { ...document, SendSign: false };
            }
          }),
        ).then(async (updatedDocuments) => {
          // setListSignDocuments(updatedDocuments);
          setLoadView(false);
          try {
            for (let i = 0; i < documentsProcedSign.length; i++) {
              const doc = documentsProcedSign[i];
              const isLastDocument = i === documentsProcedSign.length - 1;
              if (doc.IsValidedSat) {
                const props = {
                  title: 'Error en Firma Electrónica',
                  text: doc.messageConfirm,
                  icon: 'warning',
                  okbtntext: 'Aceptar',
                  notbtntext: 'Cancelar',
                };

                const response = await AlertConfirmAsync(props);
                console.log(`Documento: ${doc.documentId}, Respuesta: ${response.status}`);
                if (response.status === 'aprobado') {
                  setStatusOCSP(true);
                  setStatuSingBlocked(false);

                  const resSign = await documentsRequests.DigitalSignSATDocument(
                    constructBodySign(
                      doc.cerb64,
                      doc.firmab64,
                      doc.fileId,
                      doc.documentId,
                      isLastDocument,
                    ),
                  );
                  console.log('DigitalSignSATDocument---resSign 1: ', resSign);
                  if (resSign.IsOK && isLastDocument) {
                    navigateNextStage(resSign.Body, doc.fileId);
                  }
                  confirmedDocuments.push(doc.documentId);
                }
              } else {
                const resSign = await documentsRequests.DigitalSignSATDocument(
                  constructBodySign(
                    doc.cerb64,
                    doc.firmab64,
                    doc.fileId,
                    doc.documentId,
                    isLastDocument,
                  ),
                );
                console.log('DigitalSignSATDocument---resSign 2: ', resSign);
                if (resSign.IsOK && isLastDocument) {
                  navigateNextStage(resSign.Body, doc.fileId);
                }
                confirmedDocuments.push(doc.documentId);
              }
            }

            // Actualizar la lista de documentos firmados
            setListSignDocuments((prevDocs) =>
              prevDocs.map((doc) =>
                confirmedDocuments.includes(doc.Document.Id) ? { ...doc, SendSign: true } : doc,
              ),
            );
          } catch (error) {
            console.log('Error en la firma de documentos', error);
            Alert({ icon: 'error', text: error?.message || 'Error al firmar los documentos.' });
          }
        });
      } catch (err) {
        handleError(err);
      } finally {
        cleanupSession();
      }
    } else {
      handleMissingInputs();
    }
  };

  const navigateNextStage = (response, fileId) => {
    const { Stage } = response;
    let nextComponent = coreFunctions.GetLegoNext(Stage.Name);
    console.log('nextComponent', nextComponent, ' - FileId: ', fileId);
    coreFunctions.DoNextStage({
      navigate,
      nextComponent,
      State: {
        stageName: Stage.Name,
        stageId: Stage.Id,
        folioId: fileId,
      },
    });
  };

  const constructBodySign = (cerb64, firmab64, fileId, documentId, workFlowContinue = true) => {
    return {
      B64Certificado: cerb64,
      B64Firma: firmab64,
      signedAtFEA: new Date().toISOString(),
      Latitude: lat,
      Longitud: lon,
      MacAddress: 'FC:01:7C:45:48:3F',
      File_Id: fileId,
      ContinueWorkFlow: workFlowContinue,
      Document_Id: documentId,
      RespuestaOcsp: 'good',
    };
  };

  const handleNoInternet = () => {
    setStatusOCSP(false);
    setStatuSingBlocked(true);
    Alert({
      title: 'Lo sentimos',
      icon: 'error',
      okbtntext: 'Entendido',
      html: renderToString(
        <Box>
          <Typography textAlign={'justify'} sx={{ maxWidth: 400, mx: 'auto' }}>
            Por el momento no tienes conexion a internet, espera que tu conexión se reestablesca
            para el proceso de verficación.
          </Typography>
          <Divider sx={{ maxWidth: 300, mt: 3, mx: 'auto' }} />
        </Box>,
      ),
    });
  };

  const handleError = (err) => {
    console.log(err);
    setLoadView(false);
    setStatuSingBlocked(false);
    Alert({ icon: 'error', text: 'Hubo un error al firmar el documento.' });
  };

  const cleanupSession = () => {
    if (navigator.onLine) {
      sessionStorage.removeItem('firmab64');
      setkeyfile('');
      setcerfile('');
      setValues({ ...values, password: '' });
      cerref.current.value = '';
      keyref.current.value = '';
      setStatusFirma(false);
      setStatusOCSP(false);
      setStatuSingBlocked(false);
    }
  };

  const handleMissingInputs = () => {
    setLoadView(false);
    if (!values.password) {
      ToastNotification({ icon: 'error', text: 'La contraseña es requerida.' });
    }
    if (!keyfile || !cerfile) {
      ToastNotification({ icon: 'error', text: 'Debes cargar los archivos solicitados.' });
    }
  };

  return (
    <GenericContainer>
      <GeoLocationGeneric
        SuccessFN={(latitude, longitude) => {
          console.log('succes,latitude, longitude ', latitude, longitude);
          setLat(latitude);
          setLon(longitude);
        }}
        ErrorFN={(error) => console.log('error', error)}
      />
      <Typography variant="h6"> {t('signature_advanced_title')}</Typography>
      <Grid dsiplay="flex" justifyContent="center" alignItems="center" xs={12} lg={10}>
        <Box style={{ width: '100%' }}>
          <Box style={{ marginTop: 2 }}>
            <Typography variant="subtitle" style={{ fontWeight: 500 }}>
              Estatus de firma
            </Typography>
          </Box>
          <Box
            style={{
              display: 'flex',
              marginTop: '1em',
              alignItems: 'center',
              borderBottom: 0.9,
              borderColor: 'secondary.main60',
            }}
          >
            <Box style={{ marginRight: '.7em' }}>
              <CompassCalibrationIcon
                fontSize="medium"
                style={{
                  color: navigator.onLine ? 'green' : 'red',
                }}
              />
            </Box>
            <Box>
              <Typography variant="subtitle">Conexión a internet</Typography>
            </Box>
          </Box>
          <Box
            style={{
              display: 'flex',
              marginTop: '1em',
              alignItems: 'center',
              borderBottom: 0.9,
              borderColor: 'secondary.main60',
            }}
          >
            <Box style={{ marginRight: '.7em' }}>
              <HighlightOffIcon
                fontSize="medium"
                style={{
                  color: statusFirma ? 'green' : 'red',
                }}
              />
            </Box>
            <Box>
              <Typography variant="subtitle">Documento firmado</Typography>
            </Box>
          </Box>
          <Box
            style={{
              display: 'flex',
              marginTop: '1em',
              alignItems: 'center',
              borderBottom: 0.9,
              borderColor: 'secondary.main60',
            }}
          >
            <Box style={{ marginRight: '.7em' }}>
              <HighlightOffIcon
                fontSize="medium"
                style={{
                  color: statusOCSP ? 'green' : 'red',
                }}
              />
            </Box>
            <Box>
              <Typography variant="subtitle">Certificado validado</Typography>
            </Box>
          </Box>

          <Box
            style={{
              marginTop: '1.5em',
              borderColor: 'secondary.main60',
            }}
          >
            <Typography variant="subtitle" style={{ fontWeight: 500 }}>
              Selecciona los archivos solicitados
            </Typography>
            <Button
              disabled={statuSingBlocked}
              fullWidth
              style={{
                marginBottom: 1,
                justifyContent: 'flex-start',
                color: '#000',
              }}
              onClick={handleCerInput}
            >
              <input
                ref={cerref}
                disabled={statuSingBlocked}
                onChange={handleCerFile}
                style={{ visibility: 'hidden', width: 0 }}
                type="file"
                accept=".cer,.cert"
              />
              <Box
                style={{
                  display: 'grid',
                  placeContent: 'center',
                  padding: 2,
                  borderRadius: 2,
                  marginTop: '1.5em',
                  opacity: cerfile ? 1 : 0.5,
                }}
              >
                <AttachFileOutlined
                  fontSize="large"
                  style={{ color: cerfile ? 'red' : '#DADADA' }}
                />
              </Box>
              <Box
                style={{
                  flexGrow: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  marginLeft: 3,
                }}
              >
                <Typography variant="subtitle1" component="p">
                  Archivo .CER<spam style={{ color: MAIN_COLOR, marginLeft: 3 }}> * </spam>
                </Typography>
                <Typography variant="caption" component="p">
                  Certificado digital
                </Typography>
              </Box>
              <ArrowForwardIosIcon />
            </Button>
            <Button
              fullWidth
              disabled={statuSingBlocked}
              style={{ justifyContent: 'flex-start', color: '#000' }}
              onClick={handleKeyInput}
            >
              <input
                disabled={statuSingBlocked}
                ref={keyref}
                onChange={handleKeyFile}
                style={{ visibility: 'hidden', width: 0 }}
                type="file"
                accept=".key"
              />
              <Box
                style={{
                  display: 'grid',
                  placeContent: 'center',
                  p: 2,
                  marginTop: '1.5em',
                  borderRadius: 2,
                  opacity: keyfile ? 1 : 0.5,
                }}
              >
                <AttachFileOutlined
                  fontSize="large"
                  style={{ color: keyfile ? 'red' : '#DADADA' }}
                />
              </Box>
              <Box
                style={{
                  flexGrow: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  ml: 3,
                }}
              >
                <Typography variant="subtitle1" component="p">
                  Archivo .KEY<spam style={{ color: MAIN_COLOR, marginLeft: 3 }}> * </spam>
                </Typography>
                <Typography variant="caption" component="p">
                  Clave privada
                </Typography>
              </Box>
              <ArrowForwardIosIcon />
            </Button>
          </Box>

          <Box style={{ marginTop: '2em' }}>
            <FormControl fullWidth size="small" variant="outlined">
              <InputLabel htmlFor="outlined-adornment-password">
                {t('signature_advanced_clave')}
              </InputLabel>
              <OutlinedInput
                disabled={statuSingBlocked}
                type={values.showPassword ? 'text' : 'password'}
                value={values.password}
                onChange={handleChange('password')}
                onKeyDown={(e) => {
                  if (e.key == 'Enter' && e.shiftKey === false) {
                    handleSignature();
                  }
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {values.showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                label={t('signature_advanced_clave')}
                inputProps={{
                  outlinet: 'none',
                  autoComplete: 'new-password',
                  form: {
                    autoComplete: 'off',
                  },
                }}
              />
            </FormControl>
          </Box>
        </Box>
      </Grid>

      <Buttons
        ConfirmButtonText={t('signature_advanced_confirmButton')}
        onClickConfirm={handleSignature}
        marginBottom={10}
        // onClickCancel={() => {}}
      />

      {loadView ? (
        <CustomLoadingOverlay active={loadView} text={t('general_loading_advancedsign')} />
      ) : null}
    </GenericContainer>
  );
}
